<template>
  <Card tag="form" class="page-mutate-presentation" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="page-mutate-presentation__input">
        <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

        <CustomFields
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="value"
          :placement="['presentation', 'page:presentation', undefined, null]"
          @remove="$ev => removeCustomField($ev)"
          :validator="validator"
          validator-prefix="customFields"
          :disabledFields="$path('metadata.disabledFields.page', item)"
        >
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { i18n } from '@/i18n'
import { assocPath } from 'ramda'
import { MediaComponent } from '@kvass/media'
import Card from '@/components/Card'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Page/StepsFields/FieldRenderer.vue'

const meta = {
  order: 3,
  id: 'presentation',
  label: i18n.tc('presentation'),
  icon: ['fal', 'image'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('Page', ['getDisabledField']),
    ...mapState('Page', {
      item: state => state.item,
    }),
  },
  methods: {
    addCustomField(item) {
      this.value.customFieldsConfig.push({
        source: item.id,
        placement: 'presentation',
        schema: item.fields,
      })
    },
    removeCustomField(item) {
      this.value.customFields = assocPath(item.key.split('.'), null, this.value.customFields)
      this.value.customFieldsConfig = this.value.customFieldsConfig.filter(c => c.source !== item.source)
    },
  },
  components: {
    Card,
    CustomFields,
    MediaComponent,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.page-mutate-presentation {
  $cols: 6;

  &__header {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    padding: var(--card-spacing);
    padding-bottom: 0;

    p {
      margin: 0;
    }
  }

  & > .card__content {
    padding: 0;
  }

  &__cutoff {
    background: linear-gradient(css-alpha('border-color', 0.4), css-alpha('border-color', 0)) !important;
    @include cutoff(#fff, css-alpha('border-color', 0.2));
    margin: 2rem calc(-1 * var(--card-spacing)) calc(-1 * var(--card-spacing)) calc(-1 * var(--card-spacing));
    padding: calc(var(--card-spacing) * 2) var(--card-spacing) var(--card-spacing);
    font-size: 0.7em;
    grid-column-end: span var(--columns);
  }

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;

    padding: var(--card-spacing);
  }

  [data-field='media.logo'],
  [data-field='media.logoInverted'],
  [data-field='media.favicon'] {
    grid-column-end: span $cols/3 * 1;
    height: 100% !important;

    .kvass-media-droparea {
      min-height: 200px;
    }
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
